import { request } from '../../helpers/api/request';

export const deleteBrand = async (id: number) => {
    const { data } = await request({
        url: `admin/brands/${id}`,
        method: 'DELETE',
    });

    return data;
};
